import {
	GET_SITES,
	SET_SELECTED_SITES,
	GET_TRACKER_LAST_UPDATE
} from '../actions/ReportsActions';

const initialState = {
	operators: [],
	openAddOperatorDialog: false,
	detailsOperatorId: null,
	operator: {},
	formState: {
		isValid: false,
		values: {},
		touched: {},
		errors: {},
	},
	openAddProjectDialog: false,
	sites: [],
	selectedSites: [],
	lastUpdate: null
};

const reportsReducer = (state = initialState, action) => {
	switch (action.type) {
					case GET_SITES: {
						return {
							...state,
							sites: action.sites
						};
					}
					case SET_SELECTED_SITES: {
						return {
							...state,
							selectedSites: action.selectedSites
						};
					}
					case GET_TRACKER_LAST_UPDATE: {
						return {
							...state,
							lastUpdate: action.lastUpdate
						};
					}
					default: {
						return state;
					}
	}
};

export default reportsReducer;
